import { useEffect, useState } from "react";

/// How often the clock is re-read. Half a minute, so a displayed minute is
/// never more than thirty seconds behind the real one.
const TICK_MS = 30_000;

/**
 * A `Date` that actually moves.
 *
 * Elapsed time was computed from `new Date()` during render, which only
 * re-evaluates when something else re-renders the component. Sitting on one
 * page, "Checked in 0m" stayed 0m for the rest of the day, and navigating made
 * it jump in irregular steps, which reads worse than no number at all.
 *
 * `enabled` so the timer only runs when a duration is on screen. A person who
 * is not checked in has no elapsed time to show, and a render every thirty
 * seconds to change nothing is a cost with no reader.
 */
export function useMinuteTick(enabled: boolean): Date {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    if (!enabled) return;
    // Set once on enable too: the state may have been captured minutes ago,
    // before the tap that made this relevant.
    setNow(new Date());
    const id = setInterval(() => setNow(new Date()), TICK_MS);
    return () => clearInterval(id);
  }, [enabled]);

  return now;
}
